import React, { useEffect, useRef } from 'react';

import CommonImage from '@/components/CommonImage';
import { isAdmin } from '@/utils/Util';
import InputField from '@/components/InputField';

const FilterConfigurationTopBar = ({
	onSearch = () => {},
	itemCount = 0,
	setOpenPrimarySettings,
	searchKey,
	totalCategoryItem
}) => {
	const searchRef = useRef(null);

	useEffect(() => {
		if (searchRef?.current) {
			searchRef.current.focus();
		}
	}, []);

	return (
		<div className="task-configuration-header d-flex align-items-center justify-content-between py-2">
			<p className="semibold-14 gray_dark_02">
				{totalCategoryItem ? `${totalCategoryItem} items` : `${itemCount} items`}
			</p>
			<div className="task-action d-flex align-items-center">
				<div className="form-group size32 m-0 mr-1 search-filter filter-with-animation">
					<div className="with-icon right-icon">
						<InputField
							type="text"
							placeholder="Search"
							value={searchKey}
							onChangeHandler={(e) => onSearch(e.target.value)}
							withWrapper={false}
							ref={searchRef}
							withLabel={false}
						/>
						<span className="right-icon">
							<CommonImage src="/icons/search.png" alt="search icon" />
						</span>
					</div>
				</div>
				{isAdmin() && (
					<div className="add-new-design">
						<button
							className="button text size32 px-0 pb-0"
							onClick={() => setOpenPrimarySettings(true)}
						>
							<CommonImage src="/icons/add-round.svg" alt="add" />
							<span className="ml-1 gray_dark_02">List</span>
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default FilterConfigurationTopBar;
